/**
 * Yo'lga asoslangan ikki tillilik.
 *
 *   o'zbekcha  →  /                 /xizmatlar         /xizmatlar/<uz-slug>
 *   ruscha     →  /ru               /ru/uslugi         /ru/uslugi/<ru-slug>
 *
 * Nega query emas: `?lang=ru` Google uchun alohida sahifa emas — ruscha
 * kontent umuman indekslanmaydi. Prefiks bilan har til o'z URL'iga ega
 * bo'ladi va hreflang juftligi ishlaydi.
 */

export const LOCALES = ['uz', 'ru'];
export const DEFAULT_LOCALE = 'uz';

/** Ruscha yo'llar `/ru` bilan boshlanadi. */
export function localeFromPath(pathname = '/') {
    return /^\/ru(\/|$)/.test(pathname) ? 'ru' : 'uz';
}

/** `/ru/uslugi/x` → `/uslugi/x`; `/xizmatlar` → `/xizmatlar` */
export function stripLocale(pathname = '/') {
    const out = pathname.replace(/^\/ru(?=\/|$)/, '');
    return out === '' ? '/' : out;
}

/** Berilgan yo'lni tanlangan tilga o'tkazadi. */
export function withLocale(pathname, locale) {
    const bare = stripLocale(pathname);
    if (locale !== 'ru') return bare;
    return bare === '/' ? '/ru' : `/ru${bare}`;
}

/** Xizmatlar ro'yxati sahifasi */
export function servicesRoot(locale) {
    return locale === 'ru' ? '/ru/uslugi' : '/xizmatlar';
}

/** Bitta xizmat sahifasi. `service` — SERVICES dagi element. */
export function servicePathFor(service, locale) {
    return locale === 'ru' ? `/ru/uslugi/${service.ru}` : `/xizmatlar/${service.slug}`;
}

/**
 * Blog ro'yxati sahifasi.
 * Maqolaning o'zi uchun `postPath()` ishlatiladi (src/content/blog) —
 * u ruscha slug'ni reyestrdan oladi, chunki uz va ru URL'lari har xil.
 */
export function blogRoot(locale) {
    return locale === 'ru' ? '/ru/blog' : '/blog';
}

/**
 * Joriy sahifaning boshqa tildagi juftligi — hreflang va til almashtirgich
 * uchun. Xizmat sahifalarida slug ham almashadi, shuning uchun `service`
 * berilishi mumkin.
 */
export function alternatePath(pathname, currentLocale, service = null) {
    const other = currentLocale === 'ru' ? 'uz' : 'ru';
    if (service) return servicePathFor(service, other);

    const bare = stripLocale(pathname);
    if (bare === '/xizmatlar' || bare === '/uslugi') return servicesRoot(other);

    return withLocale(bare, other);
}

/** HTML lang atributi uchun */
export function htmlLang(locale) {
    return locale === 'ru' ? 'ru' : 'uz';
}
